import React from "react";
import { Card, CardBody, CardTitle, CardSubtitle, CardText } from "reactstrap";
import StudentStatus from "./StudentStatus";

const StudentResult = props => {
  let resultStatus;

  if (props.result.status)
    resultStatus = <StudentStatus status={props.result.status} />;

  return (
    <Card>
      <CardBody>
        <CardTitle>
          {props.result.module}{" "}
          <small className="pull-right">{resultStatus}</small>
        </CardTitle>
        <CardSubtitle className="text-primary">
          Kurs: {props.result.courseName}{" "}
          <small className="pull-right">
            <i className="fa fa-clock-o" />
          </small>
        </CardSubtitle>
        <CardText>
          Resultat: {props.result.score}/{props.result.maxScore}
          <br />
          Aktivitetspoäng: {props.result.activityPoints}/
          {props.result.maxActivityPoints}
          <br />
          Gräns för godkänt: {props.result.approveLimit}
        </CardText>
      </CardBody>
    </Card>
  );
};

export default StudentResult;
